export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081/api";
export const ENV = process.env.REACT_APP_ENV;
export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:8081/";
export const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
